import { Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';

@Component({
  selector: 'debtor-panel-common-nav-bar',
  templateUrl: './common-nav-bar.component.html',
  styleUrls: ['./common-nav-bar.component.scss'],
  imports: [TranslateModule, BreadcrumbComponent],
})
export class CommonNavBarComponent {
  public backToText = input<string>('order-contact.back-to-dashboard');
  public navigateTo = output();

  protected navigateToClick(event: Event): void {
    event.preventDefault();
    this.navigateTo.emit();
  }
}
